import React, { useState, useEffect } from "react";
import "aos/dist/aos.css";
import { Button, Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import "./footer.css";
import newLogo from "../../assets/eksiogluPictures/eksiogluWhiteLogo-small.png";

// React Icons
import { FaInstagram } from "react-icons/fa";
import { FaFacebookSquare } from "react-icons/fa";
import { FaPhone } from "react-icons/fa";
import { FiMail } from "react-icons/fi";
import { FaLinkedin } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import ThirdPartyGate from "components/CookieConsent/ThirdPartyGate";
import { useCookieConsent } from "components/CookieConsent/CookieConsentProvider";

function Footer() {
  const [posts, setPosts] = useState([]);
  const [error, setError] = useState("");
  const { openSettings } = useCookieConsent();

  //@TODO
  const items = JSON.parse(sessionStorage.getItem("blogData"));

  const fetchBlogData = async () => {
    axios
      .get("https://eksiogluhukukofisi.pythonanywhere.com/postApi/posts/")
      .then((response) => {
        const updatedPosts = response.data.slice(-10);
        setPosts(updatedPosts);
        sessionStorage.setItem("blogData", JSON.stringify(updatedPosts));
      })
      .catch((error) => {
        setError(error.message || "Veri çekilirken hata oluştu.");
      });
  };

  useEffect(() => {
    (items?.length === 0 || items === null) && fetchBlogData();
  }, [items]);

  return (
    <footer className="footer bg-[#252526] md:rounded-tr-[20%] md:rounded-tl-[20%] font-sans">
      <div className="flex flex-col w-full h-full gap-6 text-white md:px-20 px-10">
        <div className="flex lg:flex-row flex-col lg:items-start items-center lg:gap-0 gap-6 w-full h-full">
          <div className="flex lg:w-1/3 w-full h-full justify-center">
            <img
              src={newLogo}
              alt="logo"
              width={200}
              height={60}
              title="EKŞİOĞLU HUKUK"
              loading="eager"
              rel="preload"
              className=""
            />
          </div>
          <div className="flex flex-col md:items-start items-center lg:w-1/3 w-full h-full">
            <div className="font-bold text-lg mb-4">Menü</div>
            <div className="flex flex-col h-full justify-center md:items-start items-center gap-1">
              <a className="text-white" href="/">
                Ana Sayfa
              </a>
              <a className="text-white" href="/hakkimizda">
                Hakkımızda
              </a>
              <a className="text-white" href="/blog">
                Blog Paylaşımları
              </a>
              <a className="text-white" href="/">
                Videolar
              </a>
              <a className="text-white" href="/iletisim">
                İletişim
              </a>
              <a
                className="text-white"
                href="https://www.hasarhukukkurumsal.com/login"
              >
                Ekşioğlu Portal
              </a>
            </div>
          </div>
          <div className="flex flex-col md:items-start items-center lg:w-1/3 w-full h-70 ">
            <div className="font-bold text-lg mb-4">Hizmetlerimiz</div>
            <div className="flex flex-col h-full justify-center md:items-start items-center gap-1">
              <div>
                <a
                  className="text-white"
                  href="/ozel-hukuk/sozlesmeler-ve-borclar-hukuku"
                >
                  Özel Hukuk
                </a>
              </div>
              <div>
                <a className="text-white" href="/kamu-hukuku/ceza-hukuku">
                  Kamu Hukuku
                </a>
              </div>
              <div>
                <a className="text-white" href="/ticaret-hukuku/ticaret-hukuku">
                  Ticaret Hukuku
                </a>
              </div>
              <div>
                <a
                  className="text-white"
                  href="/tuketici-ve-saglik-hukuku/tuketici-hukuku"
                >
                  Tüketici ve Sağlık Hukuku
                </a>
              </div>
              <div>
                <a
                  className="text-white"
                  href="/teknoloji-ve-verilerin-korunmasi-hukuku/kisisel-verilerin-korunmasi-hukuku"
                >
                  Teknoloji ve Verilerin Korunması Hukuku
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="flex md:flex-row flex-col-reverse w-full h-full lg:justify-start justify-between ">
          <div className="flex md:w-1/3 w-full justify-center xl:pl-[170px]">
            <div className="social-feed">
              <div className="feed-line">
                <ThirdPartyGate title="Harita" height={200} type="map">
                  <iframe
                    title="Ekşioğlu Hukuk Ofisi Harita"
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12059.631297201557!2d29.179745!3d40.9177669!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cad19b832a9b95%3A0x7eed51a12e72685b!2zRWvFn2lvxJ9sdSBIYXNhciBEYW7EscWfbWFubMSxxJ_EsQ!5e0!3m2!1str!2str!4v1703981049032!5m2!1str!2str"
                    width="100%"
                    height="200"
                    style={{ border: "0" }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    className="rounded-xl"
                  ></iframe>
                </ThirdPartyGate>
                <div className="feed-line">
                  <p>
                    Soğanlık Yeni Mah. Aliağa Sok. No:8 K:30 D:159 Bumerang
                    Towers Kartal/İstanbul
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="md:flex hidden  w-full justify-center"></div>
          <div className="flex flex-col w-full md:items-start items-center h-48 gap-4">
            <div className="flex flex-row items-center md:justify-start justify-center w-full gap-2">
              <FaPhone className="h-4" />
              <div>(0216) 949 03 53</div>
            </div>
            <div className="flex flex-row items-center md:justify-start justify-center w-full gap-2">
              <FiMail className="h-4" />
              <div>bilgi@eksiogluhukukofisi.com</div>
            </div>
            <div className="flex flex-row h-auto gap-4">
              <div
                className="flex justify-center items-center w-12 rounded-full bg-white cursor-pointer p-1"
                onClick={() =>
                  window.open(
                    "https://www.linkedin.com/company/ek%C5%9Fio%C4%9Flu-hukuk-dan%C4%B1%C5%9Fmanl%C4%B1k/?viewAsMember=true",
                  )
                }
              >
                <FaLinkedin className="w-8 h-8 text-blue-500 font-bold" />
              </div>
              <div
                className="flex justify-center items-center w-12 rounded-full bg-white cursor-pointer p-1"
                onClick={() =>
                  window.open(
                    "https://www.instagram.com/eksiogluhukukvedanismanlik/",
                  )
                }
              >
                <FaInstagram className="w-8 h-8 text-pink-500 font-bold" />
              </div>
              <div
                className="flex justify-center items-center w-12 rounded-full bg-white cursor-pointer p-1"
                onClick={() => window.open("https://x.com/eksioglu_hukuk")}
              >
                <FaXTwitter className="w-8 h-8 text-black font-bold" />
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm opacity-90">
          <a
            className="text-white underline-offset-2 hover:underline"
            href="/kvkk"
          >
            KVKK Aydınlatma Metni
          </a>

          <span className="hidden sm:inline opacity-60">•</span>

          <a
            className="text-white underline-offset-2 hover:underline"
            href="/acik-riza-metni"
          >
            Açık Rıza Metni
          </a>

          <span className="hidden sm:inline opacity-60">•</span>

          <a
            className="text-white underline-offset-2 hover:underline"
            href="/cerez-politikasi"
          >
            Çerez Politikası
          </a>

          <span className="hidden sm:inline opacity-60">•</span>
          <button
            type="button"
            className="text-white underline-offset-2 hover:underline bg-transparent border-0 p-0"
            onClick={openSettings}
          >
            Çerez Tercihleri
          </button>
        </div>

        <div className="copyright text-white text-center" id="copyright">
          © {new Date().getFullYear()}, Powered by{" "}
          <a className="text-white" href="/">
            Ekşioğlu Hukuk
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
